import { Component } from '@angular/core';

@Component({
    selector: 'wep-template-static',
    templateUrl: './static.html',
    host: {'class': 'tpl tpl--static'},
    styleUrls: ['./static.scss'],
})

export class StaticTemplateComponent {


    public hideSharedHeading:boolean = false;
    constructor() {
    }
}
